import { createFileRoute } from '@tanstack/react-router'

import EditBPPPage from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/containers/EditPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/kecamatan/$bppId/edit'
)({
  component: RouteComponent
})

function RouteComponent() {
  const { bppId } = Route.useParams()

  return <EditBPPPage bppId={bppId} />
}
